import React from 'react'
import { ImageScrollWrapper } from './weddings/styles'
import Image from 'next/image'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 10000, min: 1600 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1600, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 2,
  },
}

/**
 * Horizontally scrolling image carousel.
 *
 * @param {Array} images ordered list of images to display
 * @param {string[]} alts optional per-image alt text, indexed to match `images`
 * @param {string} imageAlt optional fallback alt for images without an entry in `alts`
 */
const ImageScroll = ({ images, alts = [], imageAlt = '' }) => {
  return (
    <ImageScrollWrapper>
      <div className="grid-container">
        <Carousel
          draggable={true}
          swipeable={true}
          infinite={true}
          autoPlay={false}
          responsive={responsive}
        >
          {images.map((img, i) => (
            <div key={i} className="wedding-photo-container">
              <Image src={img} alt={alts[i] || imageAlt} />
            </div>
          ))}
        </Carousel>
      </div>
    </ImageScrollWrapper>
  )
}

export default ImageScroll
